<template>
   <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
        class='ml-2'
          small
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          Assign to
        </v-btn>
      </template>
      <v-list>
        <v-list-item style='cursor: pointer;'
          v-for="(item, index) in admins"
          :key="index"
        >
          <v-list-item-title  @click='assignTo(item)'>{{ item.email }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

</template>

<script>
import { postReq} from '../helper/firestore'
import { mapFields } from 'vuex-map-fields';
export default {
    props : {
        userUID : String
    },
 methods: {
    assignTo(gcitem){
       postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/comment/assignUsertoGC',{uid:  this.userUID, gcID : gcitem.uid,gcEmail : gcitem.email},()=>{
        
        })


    },
 },
   computed: {
    ...mapFields([
      'admins',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
  },
 
}
</script>

<style>

</style>